<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  [title]="'shared:licenses.securityAlertModal.title' | i18next">
  <div modal-body>
    <mbs-alert
      [icon]="true"
      [type]="MbsPopupType.danger">
      <div [innerHTML]="'shared:licenses.securityAlertModal.description' | i18next: { percent: baseModal.data.percent }"></div>
    </mbs-alert>
  </div>
  <ng-container modalFooter>
    <mbs-button
      (click)="modal.close()"
      type="primary"
      >{{ 'shared:buttons.ok' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
